import React, { useState, useEffect } from "react";
import { Button } from "../Components/ui/button";
import { Input } from "../Components/ui/input";
import { Badge } from "../Components/ui/badge";
import {
  DotsHorizontalIcon,
  CaretSortIcon,
  FileIcon,
  PlayIcon,
  PauseIcon,
  StopwatchIcon,
  MagnifyingGlassIcon,
  CheckIcon,
} from "@radix-ui/react-icons";
import { FiFilter } from "react-icons/fi";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../Components/ui/table";
import { format } from "date-fns";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../Components/ui/dropdown-menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DropdownMenuDemo from "../Components/Filter/OperatorDataDropdown";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { RootState } from "../State/store";
import OperatorContactDetailsDialog from "./OperatorContactDetailsDialog";
import { DateRange } from "react-day-picker";

interface Data {
  connectionId: number;
  connectionName: string;
  type: string;
  status: string;
  updatedAt: string;
  recipients: number;
}

interface ContactList {
  id: number;
  filename: string;
  processedStatus: string;
  receivedTime: Date | null;
  finalEndTime: Date | null;
  totalCount: number | null;
  successCount: number | null;
  failureCount: number | null;
  duplicateCount: number | null;
}

const OperatorDataList: React.FC = () => {
  // States for API and dummy data (if needed)
  const [dataList, setDataList] = useState<Data[]>([]);
  // We'll use contactList from the API as our source of data for search/pagination
  const [contactList, setContactList] = useState<ContactList[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasData, setHasData] = useState(false);
  // const [apiUrlOpAcc, setapiUrlAOpAcc] = useState("");
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id
  );

  // States for search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredContacts, setFilteredContacts] = useState<ContactList[]>([]);
  const [currentContacts, setCurrentContacts] = useState<ContactList[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState<DateRange | undefined>();
  const [totalCount, setTotalCount] = useState(0);
  const [isClearingSearch, setIsClearingSearch] = useState(false);

  // Other states
  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [checkboxSelectedRows, setCheckboxSelectedRows] = useState<number[]>(
    []
  );
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [dateList, setDateList] = useState<string[]>([]);
  const dispatch = useDispatch();

  // New state to store sort configuration (if needed)
  const [sortKey, setSortKey] = useState<keyof Data | null>(null);
  const [sortField, setSortField] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  const [successCount, setSuccessCount] = useState(0);
  const [failureCount, setFailureCount] = useState(0);
  const [isDetailsDialogOpen, setIsDetailsDialogOpen] = useState(false);
  const [selectedListId, setSelectedListId] = useState(0);

  // (Optional) Load dummy data
  // useEffect(() => {
  //   // For testing, you might load dummyData into dataList.
  //   setDataList([]);
  // }, []);

  const apiUrlAdminAcc = useSelector(
    (state: RootState) => state.authentication.adminUrl
  );
  const apiUrlOpAcc = useSelector(
    (state: RootState) => state.authentication.operatorUrl
  );

   useEffect(() => { const d = setTimeout(() => setDebouncedSearchTerm(searchTerm), 400); return () => clearTimeout(d); }, [searchTerm]);
  

  // Once API URL is set, fetch operator contacts
  // useEffect(() => {
  //   if (apiUrlOpAcc) {
  //     GetOperatorContactsListByWorkspaceId();
  //   }
  // }, [apiUrlOpAcc]);

    useEffect(() => { GetOperatorContactsListByWorkspaceId(); /* eslint-disable-next-line */ }, [workspaceId, currentPage, rowsPerPage, debouncedSearchTerm, dateRange]);

  const GetOperatorContactsListByWorkspaceId = async () => {
    debugger
    try {
            const params: any = {
              partnerId:workspaceId,
              page: currentPage,
              rowsPerPage,
              searchTerm: debouncedSearchTerm || undefined,
            };
            if (dateRange?.from && dateRange?.to) {
              params.startDate = format(dateRange.from, "yyyy-MM-dd");
              params.endDate = format(dateRange.to, "yyyy-MM-dd");
            }
      const response = await axios.get(
        `${apiUrlOpAcc}/GetOperatorFilesStatus`, { params }
      );
      if (response.data.status === "Success") {
        debugger
        console.log(response.data.operatorFilesStatus);
        setContactList(response.data.operatorFilesStatus);
        setCurrentContacts(response.data.operatorFilesStatus); // ✅ add this
        setHasData(response.data.operatorFilesStatus.length > 0);
        setTotalCount(response.data.total);
      } else {
        console.log("Response: " + response.data.Status_Description);
        setHasData(false);
        setTotalCount(0);
      }
    } catch (e) {
      console.log("Error fetching contacts: ", e);
      setHasData(false);
      setTotalCount(0);
    } finally {
       setIsClearingSearch(false);
      setIsLoading(false);
    }
  };

    const totalPages: number = Math.ceil(totalCount / rowsPerPage);
  // Update date list whenever dataList changes (if needed)
  useEffect(() => {
    const uniqueDates = dataList.reduce(
      (acc: Record<string, string[]>, data) => {
        const date = data.updatedAt.split("T")[0];
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(date);
        return acc;
      },
      {}
    );
    setDateList(Object.keys(uniqueDates));
  }, [dataList]);

  const handleMenuToggle = (rowId: number) => {
    setOpenMenuRowId(openMenuRowId === rowId ? null : rowId);
  };


  // const handlePageChange = (newPage: number) => {
  //   if (newPage > 0 && newPage <= totalPages) {
  //     setCurrentPage(newPage);
  //   }
  // };

  // NEW SEARCH & PAGINATION LOGIC:
  // Filter contacts based on the search term using file_name
  useEffect(() => {
    const filtered = contactList.filter((item) =>
      searchTerm
        ? item.filename.toLowerCase().includes(searchTerm.toLowerCase())
        : true
    );
    setFilteredContacts(filtered);
    // setCurrentPage(1); // Reset to first page when search changes
  }, [contactList, searchTerm]);

  // Paginate the filtered contacts
  // useEffect(() => {
  //   const startIndex = (currentPage - 1) * rowsPerPage;
  //   const paginated = filteredContacts.slice(
  //     startIndex,
  //     startIndex + rowsPerPage
  //   );
  //   setCurrentContacts(paginated);
  // }, [filteredContacts, currentPage, rowsPerPage]);

  // --- END SEARCH & PAGINATION LOGIC ---

  // Sorting function remains (if needed)
  const sortaudienceList = (tableHeader: string) => {
    let key: keyof Data;
    let type: "string" | "number" | "date" = "string";
    switch (tableHeader) {
      case "ByDataName":
        key = "connectionName";
        type = "string";
        break;
      case "ByDataType":
        key = "type";
        type = "string";
        break;
      case "ByDataStatus":
        key = "status";
        type = "string";
        break;
      case "ByDataUpdatedAt":
        key = "updatedAt";
        type = "date";
        break;
      case "ByDatarecipients":
        key = "recipients";
        type = "number";
        break;
      default:
        console.warn("Unknown table header");
        return;
    }

    // Toggle direction if sorting on the same key; otherwise, default to ascending.
    let direction: "asc" | "desc" = "asc";
    if (sortKey === key) {
      direction = sortDirection === "asc" ? "desc" : "asc";
    }
    setSortKey(key);
    setSortDirection(direction);

    const sortedAudiences = [...dataList].sort((a, b) => {
      if (type === "number") {
        return direction === "asc"
          ? Number(a[key]) - Number(b[key])
          : Number(b[key]) - Number(a[key]);
      } else if (type === "date") {
        return direction === "asc"
          ? Date.parse(a[key] as string) - Date.parse(b[key] as string)
          : Date.parse(b[key] as string) - Date.parse(a[key] as string);
      } else {
        return direction === "asc"
          ? String(a[key]).localeCompare(String(b[key]))
          : String(b[key]).localeCompare(String(a[key]));
      }
    });
    setDataList(sortedAudiences);
  };

  const renderStatusIcon = (status: any) => {
    switch (status) {
      case "Syncing...":
        return <StopwatchIcon className="text-gray-500" />;
      case "Updated":
        return (
          <CheckIcon className="text-gray-500 rounded-full border border-gray-500" />
        );
      default:
        return null;
    }
  };

  const handleView = (audienceId: number, total_people: number) => {
    console.log(`View audience with ID: ${audienceId}`);
    setSelectedListId(audienceId);
    setSuccessCount(total_people);
    setIsDetailsDialogOpen(true);
  };

  // Update handleSelectAll to work on the current paginated contacts
  const handleSelectAll = () => {
    if (isAllSelected) {
      setCheckboxSelectedRows([]);
    } else {
      const allIds = currentContacts.map((data) => data.id);
      setCheckboxSelectedRows(allIds);
    }
    setIsAllSelected(!isAllSelected);
  };



const sortOperatorFiles = (field: string) => {
  debugger
  let type: "string" | "number" | "date" = "string";

  switch (field) {
    case "ByFilename":
      type = "string";
      break;
    case "ByStatus":
      type = "string";
      break;
    case "ByReceivedDate":
      type = "date";
      break;
    case "ByFinalEndDate":
      type = "date";
      break;
    case "ByTotalCount":
      type = "number";
      break;
    case "BySuccessCount":
      type = "number";
      break;
    case "ByFailureCount":
      type = "number";
      break;
    case "ByDuplicateCount":
      type = "number";
      break;
    default:
      break;
  }

  // Toggle direction if clicking the same field
  let direction: "asc" | "desc" = "asc";
  if (sortField === field) {
    direction = sortDirection === "asc" ? "desc" : "asc";
  }
  setSortField(field);
  setSortDirection(direction);

  const sorted = [...contactList].sort((a, b) => {
    let aValue: any, bValue: any;

    switch (field) {
      case "ByFilename":
        aValue = a.filename || "";
        bValue = b.filename || "";
        break;
      case "ByStatus":
        aValue = a.processedStatus || "";
        bValue = b.processedStatus || "";
        break;
      case "ByReceivedDate":
        aValue = a.receivedTime;
        bValue = b.receivedTime;
        break;
      case "ByFinalEndDate":
        aValue = a.finalEndTime;
        bValue = b.finalEndTime;
        break;
      case "ByTotalCount":
        aValue = a.totalCount || 0;
        bValue = b.totalCount || 0;
        break;
      case "BySuccessCount":
        aValue = a.successCount || 0;
        bValue = b.successCount || 0;
        break;
      case "ByFailureCount":
        aValue = a.failureCount || 0;
        bValue = b.failureCount || 0;
        break;
      case "ByDuplicateCount":
        aValue = a.duplicateCount || 0;
        bValue = b.duplicateCount || 0;
        break;
      default:
        return 0;
    }

    if (type === "number") {
      return direction === "asc" ? aValue - bValue : bValue - aValue;
    } else if (type === "date") {
      return direction === "asc"
        ? new Date(aValue).getTime() - new Date(bValue).getTime()
        : new Date(bValue).getTime() - new Date(aValue).getTime();
    } else {
      return direction === "asc"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    }
  });

  setCurrentContacts(sorted);
};


return (
  <div>
    <ToastContainer />
    {isLoading ? (
      <div className="flex flex-col items-center justify-center h-[500px]">
        <CircularProgress color="primary" />
      </div>
    ) : (
      // Data loaded and available (using paginated, filtered contacts)
      <div>
        <div className="flex mt-2">
          <div>
            <Input
              placeholder="Search file by name..."
              className="w-[350px] text-[14px] font-normal text-[#171717]"
              value={searchTerm}
              onChange={(e) => {
                const newValue = e.target.value;
                if (searchTerm.trim() !== "" && newValue.trim() === "") {
                  setIsClearingSearch(true);
                }
                setSearchTerm(newValue);
              }}
            />
          </div>
        </div>

        <div className="rounded-md border mt-[4vh]">
          <div className="max-h-[60vh] overflow-y-auto">
            <Table
              className="rounded-xl whitespace-nowrap border-gray-200"
              style={{ color: "#020202", fontSize: "15px" }}
            >
              <TableHeader className="text-center text-[14px] font-medium">
                <TableRow className="sticky top-0 bg-white z-10">
                  {/* Filename */}
                  <TableHead style={{ width: "25%" }}>
                    <div className="flex items-center gap-6 justify-start cursor-pointer">
                      <input
                        type="checkbox"
                        className={`text-muted-foreground ${
                          isAllSelected
                            ? "accent-gray-700 bg-grey-700 text-red-500"
                            : ""
                        }`}
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                      Filename{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByFilename")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Processed Status */}
                  <TableHead className="text-left" style={{ width: "10%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Status{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByStatus")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Received Time */}
                  <TableHead style={{ width: "20%" }} className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Received Time{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByReceivedDate")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Final End Time */}
                  <TableHead style={{ width: "25%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Final End Time{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByFinalEndDate")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Total Count */}
                  <TableHead style={{ width: "10%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Total{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByTotalCount")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Success Count */}
                  <TableHead style={{ width: "10%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Success{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("BySuccessCount")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Failure Count */}
                  <TableHead style={{ width: "15%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Failure{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByFailureCount")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  {/* Duplicate Count */}
                  <TableHead style={{ width: "15%" }}>
                    <div className="flex items-center gap-2 justify-start">
                      Duplicates{" "}
                      <CaretSortIcon
                        onClick={() => sortOperatorFiles("ByDuplicateCount")}
                        className="cursor-pointer"
                      />
                    </div>
                  </TableHead>

                  <TableHead className="text-left"></TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className="text-left text-[14px] font-normal text-[#020617]">
                {currentContacts.length > 0 ? (
                  currentContacts.map((data) => (
                    <TableRow key={data.id}>
                      <TableCell className="flex py-4 text-green-900">
                        <div className="flex  gap-6">
                          <input
                            type="checkbox"
                            className={`accent-gray-700 bg-grey-700 text-red-500 ${
                              isAllSelected
                                ? "accent-gray-700 bg-grey-700 text-red-500"
                                : ""
                            }`}
                            checked={checkboxSelectedRows.includes(data.id)}
                          />
                          <span
                            style={{
                              color: "#020617",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {data.filename}
                          </span>
                        </div>
                      </TableCell>

                      {/* Processed Status */}
                      <TableCell style={{ width: "10%" }} className="py-4 text-left">
                        <div className="flex ">
                          <span className="flex-shrink-0">
                            {renderStatusIcon(data.processedStatus)}
                          </span>
                          <span
                            style={{
                              color: "#020617",
                              fontSize: "14px",
                              fontWeight: "400",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {data.processedStatus}
                          </span>
                        </div>
                      </TableCell>

                      {/* Received Time */}
                      <TableCell style={{ width: "15%" }} className="py-4">
                        {data.receivedTime ? (
                          <span
                            style={{
                              color: "#020617",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {new Date(data.receivedTime).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )}{" "}
                            ∙{" "}
                            {new Date(data.receivedTime).toLocaleTimeString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </TableCell>

                      {/* Final End Time */}
                      <TableCell style={{ width: "20%" }} className="py-4">
                        {data.finalEndTime ? (
                          <span
                            style={{
                              color: "#020617",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {new Date(data.finalEndTime).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )}{" "}
                            ∙{" "}
                            {new Date(data.finalEndTime).toLocaleTimeString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </TableCell>

                      {/* Total Count */}
                      <TableCell className="text-left" style={{ width: "15%" }}>
                        <span
                          style={{
                            color: "#020617",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {data.totalCount?.toLocaleString() ?? "—"}
                        </span>
                      </TableCell>

                      {/* Success Count */}
                      <TableCell className="text-left" style={{ width: "10%" }}>
                        <span style={{ fontSize: "14px", fontWeight: "400" }}>
                          {data.successCount?.toLocaleString() ?? "—"}
                        </span>
                      </TableCell>

                      {/* Failure Count */}
                      <TableCell className="text-left" style={{ width: "15%" }}>
                        <span style={{ fontSize: "14px", fontWeight: "400" }}>
                          {data.failureCount?.toLocaleString() ?? "—"}
                        </span>
                      </TableCell>

                      {/* Duplicate Count */}
                      <TableCell className="text-left" style={{ width: "15%" }}>
                        <span
                          style={{
                            color: "#020617",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {data.duplicateCount?.toLocaleString() ?? "—"}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      className="text-center py-4 text-gray-500 font-medium"
                    >
                      {isLoading || isClearingSearch
                        ? "Loading..."
                        : searchTerm.trim() !== ""
                        ? "No files found for the searched item."
                        : "No files found."}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>

          <OperatorContactDetailsDialog
            open={isDetailsDialogOpen}
            onOpenChange={setIsDetailsDialogOpen}
            successCount={successCount}
            failureCount={failureCount}
            apiEndpoint={apiUrlOpAcc}
            list_id={selectedListId ?? 0}
          />
        </div>

        {/* Pagination controls */}
        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center space-x-2 text-gray-500 text-sm">
            <span>{`${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
              currentPage * rowsPerPage,
              totalCount
            )} of ${totalCount} row(s) selected`}</span>
          </div>

          <div className="flex items-center space-x-4 font-medium text-sm">
            <span className="text-[#020617] font-medium text-[14px]">
              Rows per page
            </span>
            <div className="relative inline-block ml-2">
              <select
                className="cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-yellow-400"
                style={{
                  width: "60px",
                  height: "30px",
                  textAlign: "left",
                  fontSize: "12px",
                  fontWeight: "400",
                  borderColor: "#E5E7EB",
                  boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
                }}
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                {[5, 10, 20].map((num) => (
                  <option
                    className="text-[12px] font-normal"
                    key={num}
                    value={num}
                  >
                    {num}
                  </option>
                ))}
              </select>
              <CaretSortIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
            </div>

            <div className="ml-4 mr-4">
              <span className="text-[#020617] text-[14px] font-medium">{`Page ${currentPage} of ${totalPages}`}</span>
            </div>

            <div className="flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                  currentPage === 1
                    ? "cursor-not-allowed bg-gray-100"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => setCurrentPage(1)}
              >
                «
              </button>
              <button
                disabled={currentPage === 1}
                className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                  currentPage === 1
                    ? "cursor-not-allowed bg-gray-100"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                ‹
              </button>
              <button
                disabled={currentPage === totalPages}
                className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                  currentPage === totalPages
                    ? "cursor-not-allowed bg-gray-100"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                ›
              </button>
              <button
                disabled={currentPage === totalPages}
                className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                  currentPage === totalPages
                    ? "cursor-not-allowed bg-gray-100"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => setCurrentPage(totalPages)}
              >
                »
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

};

export default OperatorDataList;
